import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MessagesStore } from '../stores';
import { IACarousel } from '../../carousel/Carousel';
import { IMessage } from '../../../interfaces/IMessage';
import { ILike } from '../../../interfaces/ILike';
import { ICarouselContentElement } from '../../../interfaces/ICarouselContentElement';
import { Helper } from '../../../Helper';

export interface ICarouselViewProps {
  messagesStore?: MessagesStore;
}

@inject('messagesStore')
@observer
export default class CarouselView extends React.Component<ICarouselViewProps> {

  constructor(props, state) {
    super(props, state);
  }

  public render(): JSX.Element {
    let elements: ICarouselContentElement[] = [];
    const startIndex = (this.props.messagesStore.pageNumber - 1) * this.props.messagesStore.numMessages;
    const endIndex = this.props.messagesStore.pageNumber * this.props.messagesStore.numMessages;
    const itemsToShow: IMessage[] = this.props.messagesStore.messages?.slice(startIndex, endIndex)
    if (itemsToShow?.length > 0) {
      itemsToShow.forEach((message: IMessage) => {
        let content = message.content;
        if (!content) {
          content = "";
        }
        let div = document.createElement("div");
        div.innerHTML = content.replace(/<\/p>/g, "</p> ").replace(/<\/h1>/g, "</h1> ").replace(/<\/h2>/g, "</h2> ").replace(/<\/li>/g, "</li> ");
        let contentText = (this.props.messagesStore.instance?.settings?.enableTeaser || localStorage.getItem("enableTeaser")) && message.teaser ? message.teaser : (div.textContent || div.innerText || "");
        let author = message.author;
        if (message.contacts != undefined && message.contacts.length > 0) {
          author = message.contacts[0];
        }
        let videoUrl = message?.videoUrl;
        if ((location.href.includes("sharepoint.com") && message?.videoEmbedCode) || (videoUrl == undefined && message?.videoEmbedCode)) {
          videoUrl = Helper.getVideoSrcFromEmbedCode(message.videoEmbedCode);
        }
        elements.push(
          {
            author: author,
            id: message.id.toString(),
            item: message,
            title: message.title,
            image: message.image,
            iaMessageBgImagesFromBlob: message.iaMessageBgImagesFromBlob,
            iaConfiguration: message.iaConfiguration,
            videoUrl: videoUrl,
            teaser: contentText,
            categories: message.categories ?? [],
            startDate: message.startDate,
            likes: message.likes,
            commentCount: message.commentCount,
            uniqueViewsCount: message.uniqueViews,
            isUnread: !message.isRead && this.props.messagesStore.instance?.settings?.enableReadUnreadMessage,
            showPinIcon: message.isPinned && (new Date(message.pinnedEndDate) > new Date())
          }
        );
      });
    } else if (this.props.messagesStore.loading) {
      elements.push(
        {}
      );
      elements.push(
        {}
      );
      elements.push(
        {}
      );
      elements.push(
        {}
      );
      elements.push(
        {}
      );
    }

    return (
      <div
        style={{
          width: "100%",
          height: "auto"
        }}
      >
        <IACarousel
          id={this.props.messagesStore.id}
          elements={elements}
          tenant={this.props.messagesStore.tenant}
          component="Message"
          fontSlots={this.props.messagesStore.fontSlots}
          userLocation={this.props.messagesStore.userLocation}
          instance={this.props.messagesStore.instance.instanceName}
          token={this.props.messagesStore.token}
          environment={this.props.messagesStore.environment}
          source="SharePoint"
          user={this.props.messagesStore.user}
          carouselInterval={this.props.messagesStore.carouselInterval}
          width={this.props.messagesStore.width}
          likesEnabled={this.props.messagesStore.likesEnabled}
          commentsEnabled={this.props.messagesStore.commentsEnabled}
          itemTitleColor={this.props.messagesStore.headLineColor}
          itemTextColor={this.props.messagesStore.textColor}
          isMobile={this.props.messagesStore.isMobile}
          showSkeleton={this.props.messagesStore.loading}
          highlightColor={this.props.messagesStore.rollupHighlightColor}
          borderColor={this.props.messagesStore.borderColor}
          borderRadius={this.props.messagesStore.borderRadius}
          backgroundColor={this.props.messagesStore.backgroundColor}
          numberOfElements={3}
          showEmojiPickerExpandButton={this.props.messagesStore.instance?.settings?.showEmojiPickerExpandButton}
          reactionOptions={this.props.messagesStore.instance?.settings?.reactionOptions}
          onClickEdit={(messageToEdit: IMessage) => {
            if (this.props.messagesStore.instance && messageToEdit?.iaConfiguration?.composerComponents) {
              this.props.messagesStore.editMessage(messageToEdit);
            } else {
              this.props.messagesStore.showConvertToComposerPopup = messageToEdit;
            }
          }}
          onClickDelete={(messageToDelete: IMessage) => this.props.messagesStore.messageToDelete = messageToDelete}
          onClickOpen={(messageToOpen: IMessage) => this.props.messagesStore.openMessage(messageToOpen)}
          likesUpdated={(likes: ILike[], itemIndex: number) => {
            this.props.messagesStore.messages[itemIndex].likes = likes;
          }}
          commentsUpdated={(comments: number, itemIndex: number) => {
            this.props.messagesStore.messages[itemIndex].commentCount = comments;
          }}
          commentsClick={(message: IMessage) => {
            this.props.messagesStore.commentsClick(message)
          }}
          showTitle={this.props.messagesStore.showTitle}
          showCategories={this.props.messagesStore.showCategories}
          showTeaser={this.props.messagesStore.showTeaser}
          showAuthor={this.props.messagesStore.showAuthor}
          showStartDate={this.props.messagesStore.showStartDate}
          showLikes={this.props.messagesStore.showLikes}
          showComments={this.props.messagesStore.showComments}
          showDropShadow={this.props.messagesStore.showDropShadow}
          messageIsOpen={this.props.messagesStore.messageToOpen != undefined || this.props.messagesStore.messageToEdit != undefined}
          showUniqueViews={this.props.messagesStore.showUniqueViews}
          unReadMessageHighlight={this.props.messagesStore.instance?.settings?.highlightUnread}
          hasDarkBackground={this.props.messagesStore.hasDarkBackground}
          showLikesDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showLikes}
          showCommentsDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showComments}
          showUniqueViewsDimmed={this.props.messagesStore.loadingUniqueViews && this.props.messagesStore.showUniqueViews}
        />
      </div>
    );
  }


}